import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface TimeSlotPickerProps {
  onTimeSlotSelect: (timeSlot: { start: string; end: string }) => void;
  selectedTimeSlot?: { start: string; end: string };
}

export const TimeSlotPicker = ({ onTimeSlotSelect, selectedTimeSlot }: TimeSlotPickerProps) => {
  // Generate 2-hour time slots from 00:00 to 22:00
  const generateTimeSlots = () => {
    const slots = [];
    for (let hour = 0; hour < 24; hour += 2) {
      const startHour = hour.toString().padStart(2, '0');
      const endHour = ((hour + 2) % 24).toString().padStart(2, '0');
      const start = `${startHour}:00`;
      const end = `${endHour}:00`;
      const label = `${start} - ${end}`;
      slots.push({ value: `${start}-${end}`, label, start, end });
    }
    return slots;
  };

  const timeSlots = generateTimeSlots();

  const handleTimeSlotChange = (value: string) => {
    const [start, end] = value.split('-');
    onTimeSlotSelect({ start, end });
  };

  return (
    <div className="space-y-2">
      <Label htmlFor="timeSlot">Select a 2-hour time window *</Label>
      <Select 
        value={selectedTimeSlot ? `${selectedTimeSlot.start}-${selectedTimeSlot.end}` : ''}
        onValueChange={handleTimeSlotChange}
      >
        <SelectTrigger>
          <SelectValue placeholder="Choose a time slot" />
        </SelectTrigger>
        <SelectContent>
          {timeSlots.map((slot) => (
            <SelectItem key={slot.value} value={slot.value}>
              {slot.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <p className="text-sm text-muted-foreground">
        Select a 2-hour time window when you need the images from the specified date.
      </p>
    </div>
  );
};